import './style/index.less'
import StopService from './StopService'

export default StopService